import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const defesaReflexa: TechniqueDefinition = {
  id: "defesa_reflexa",
  name: "Defesa Reflexa",
  description:
    "Guards briefly. If an eligible enemy attack lands during the window, damage is greatly reduced and a compatible counter technique is prepared.",
  family: "taijutsu",
  proficiency: "taijutsu",
  targeting: "self",
  behavior: { kind: "guard" },
  reactive: { kind: "guard", armsCounterReadyOnHit: true },
  levels: {
    1: {
      chakraCost: 14,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.5,
      defenseWindowMs: 800,
    },
    2: {
      chakraCost: 14,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.53,
      defenseWindowMs: 840,
    },
    3: {
      chakraCost: 15,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.55,
      defenseWindowMs: 880,
    },
    4: {
      chakraCost: 15,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.58,
      defenseWindowMs: 920,
    },
    5: {
      chakraCost: 16,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.6,
      defenseWindowMs: 960,
    },
    6: {
      chakraCost: 16,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.63,
      defenseWindowMs: 1_000,
    },
    7: {
      chakraCost: 17,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.65,
      defenseWindowMs: 1_050,
    },
    8: {
      chakraCost: 17,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.68,
      defenseWindowMs: 1_100,
    },
    9: {
      chakraCost: 18,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.7,
      defenseWindowMs: 1_150,
    },
    10: {
      chakraCost: 18,
      cooldownMs: 10_000,
      range: 1,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      damageReduction: 0.72,
      defenseWindowMs: 1_200,
    },
  },
  visual: {
    effectId: 161,
    castEffectId: 161,
  },
};
